import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import CustomAction from "../../../../controls/CustomAction";
import Lottie from "lottie-react";
import successAnimation from "./../../../../../Assets/success.json";
import calendarIcon from "./../../../../../Assets/calendar.svg";
import pinIcon from "./../../../../../Assets/pin.svg";
import envelopeIcon from "./../../../../../Assets/envelope.svg";
import cardIcon from "./../../../../../Assets/card.svg";
import phoneIcon from "./../../../../../Assets/phone.svg";
import copyIcon from "./../../../../../Assets/copy.svg";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowRight } from "react-icons/fa";
import useBookingApp from "../../../../../hooks/useBookingApp";
import { setSelectedBranch } from "../../../../../dispatchers/bookingDispatchers";

export default function AppointmentFormSuccess({ mainColor, setPreConsultation }) {
  const { bookingSectionState } = useBookingApp();
  const { selectedBranch, bookingModel, selectedServiceBookingSlot, payAmount } = bookingSectionState;
  const animRef = useRef(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      animRef?.current?.play();
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

  const [copied, setCopied] = useState(false);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const number = selectedBranch?.pharmacyContact;
  const mail = selectedBranch?.pharmacyEmail;

  useEffect(() => {
    const persistedPharmacy =
      JSON.parse(localStorage.getItem("booking-data")) || null;
    localStorage.clear();
    if (persistedPharmacy != null) {
      setSelectedBranch(persistedPharmacy);
    }
  }, []);

  return (
    <div className="bf-content-wrapper form-success-wrapper">
      <div className="form-success-parent">
        <div className="success-animation">
          <Lottie
            lottieRef={animRef}
            autoplay={false}
            animationData={successAnimation}
            loop={false}
          />
        </div>
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ type: "spring", stiffness: 100, delay: 2 }}
          exit={{ y: 50, opacity: 0 }}
          className="bf-content-body"
        >
          <div className="bf-content-header">
            <h2 className="bf-title" style={{ color: mainColor }}>
              You're all set, {bookingModel?.FirstName}!
            </h2>
            <p className="bf-subtitle">Your appointment is confirmed!</p>
          </div>

          <div className="content">
            <div className="details-box appointment-details">
              <div className="title-address">
                <div className="title-box">
                  <p className="title consultation-title">
                    {selectedBranch?.pharmacyName}
                  </p>

                  <div className="address-box">
                    <div className="icon">
                      <img src={calendarIcon} alt="icon" />
                    </div>
                    <p className="consultation-date-time">
                      {bookingModel?.AppointmentDate && (
                        <span className="date">
                          {new Date(bookingModel?.AppointmentDate).toLocaleDateString('en-GB', {
                            weekday: 'short',
                            day: '2-digit',
                            month: 'long',
                          })}
                        </span>
                      )}
                      <span className="time">{selectedServiceBookingSlot?.startTime} - {selectedServiceBookingSlot?.endTime} (1h)</span>
                    </p>
                  </div>
                </div>
              </div>

              <div className="address-box">
                <div className="icon">
                  <img src={pinIcon} alt="icon" />
                </div>
                <p>{selectedBranch?.pharmacyAddress}</p>
              </div>
              <div className="address-box">
                <div className="icon">
                  <img src={envelopeIcon} alt="icon" />
                </div>

                <p>Confirmation sent to email</p>
              </div>
              <div className="address-box-alt">
                <div className="flex">
                  <div className="icon">
                    <img src={cardIcon} alt="icon" />
                  </div>
                  <p>Deposit Paid</p>
                </div>
                <div className="flex amount">
                  <IoIosCheckmarkCircleOutline />
                  <p>£{payAmount || ""}</p>
                </div>
              </div>
            </div>

            <div className="details-box what-to-bring">
              <p className="title">What to bring</p>
              <p className="sub-text">
                Please bring a valid photo ID (e.g., passport or government-issued ID).
                If you have any relevant medical records or previous service documents,
                feel free to bring those along as well.
              </p>
            </div>

            <div className="details-box reschedule">
              <div className="title-box">
                <p className="title">Need to reschedule?</p>
                <FaArrowRight />
              </div>
              <p className="sub-text">
                You can modify or cancel your booking up to 48 hours in advance.
              </p>
            </div>
            <div className="details-box urgent-appntmnt">
              <p className="title">Urgent Appointments</p>
              <p className="sub-text">
                If you need to reschedule for a sooner appointment, you can
                contact us, here:
              </p>

              <div className="copy-box">
                <div>
                  <img src={phoneIcon} alt="copy" />
                  <p>{number}</p>
                </div>
                <img
                  src={copyIcon}
                  alt="copy"
                  className="copy-icon"
                  onClick={() => handleCopy(number)}
                />
              </div>
              <div className="copy-box">
                <div>
                  <img src={envelopeIcon} alt="copy" />
                  <p>{mail}</p>
                </div>
                <img
                  src={copyIcon}
                  alt="copy"
                  className="copy-icon"
                  onClick={() => handleCopy(mail)}
                />
              </div>
            </div>
          </div>

          <CustomAction
            text="Start pre-consultation"
            mainColor={mainColor}
            action={() => {
              setPreConsultation(true);
            }}
          />
        </motion.div>
      </div>
    </div>
  );
}
